import UploadFileIcon from '@mui/icons-material/UploadFile';
import Button from '@mui/material/Button';
import React, {FC} from 'react';
import Tooltip from '@mui/material/Tooltip';

export type UploadFileButtonProps = {
  placeholder: string
  file?: File
  onFileUpload: (file?: File) => void
  acceptMimeType?: string
};

const UploadFileButton: FC<UploadFileButtonProps> = ({
  placeholder,
  file,
  onFileUpload,
  acceptMimeType,
}) => {
  
  const buttonLabel = file ? file.name : placeholder;

  return <Tooltip title={buttonLabel}>
    <Button component="label" variant="contained" startIcon={<UploadFileIcon/>}
      sx={{width: '100%'}}>
      <span style={styles}>
        {buttonLabel}
      </span>
      <input
        type="file"
        accept={acceptMimeType}
        onChange={event => onFileUpload(event.target.files?.[0])}
        hidden
      />
    </Button>
  </Tooltip>;
};

export default UploadFileButton;

const styles = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%'
};